import { Paper, makeStyles } from "@material-ui/core"
import { observer } from "mobx-react"
import { SendWireBaseStore } from "../stores"
import { SendWireStepper } from "./sendWireStepper"
import { useParams } from "react-router"
import { useEffect, useState } from "react"
import { runInAction } from "mobx"

const useStyles = makeStyles(theme => ({
  paper: {
    border: 'none',
    borderRadius: '0px',
  },
}))

export interface SendWireProps {
  store: SendWireBaseStore;
}


export const SendWire = observer((props: SendWireProps) => {
  const classes = useStyles();
  const { store } = props;
  const { drawId, loanId } = useParams<{ drawId: string, loanId: string }>();

  const [localDrawId, setLocalDrawId] = useState(drawId);
  const [localLoanId, setLocalLoanId] = useState(loanId);

  useEffect(() => {
    if (localDrawId !== store.drawId || localLoanId !== store.loanId) {
      runInAction(() => {
        store.drawId = localDrawId;
        store.loanId = localLoanId;
      })
    }
  }, [localDrawId, localLoanId])

  useEffect(() => {
    if (localDrawId) { store.drawDQDataGridStore.fetchGridData() };
  }, [localDrawId])

  useEffect(() => {
    if (localLoanId) {
      store.consolidateDrawsGridStore.fetchGridData()
    }
  },[localLoanId])

  return (
    <Paper className={classes.paper}>
      <SendWireStepper/>
    </Paper>
  )
});